<div class="unauthorized-container">
  <div class="unauthorized-card">
    <span class="unauthorized-icon">&#9940;</span>
    <h2>Access Denied</h2>
    <p>Your role is not authorized for this page.</p>
  </div>
</div>
